import React 			from 'react';
import BLComponent 	from '../core/_BLComponent.jsx';
import {CustomAlert}	from './_Utilities.jsx';

var builder;
var renderer;
export default class Part3DViewer extends BLComponent {

	constructor(props){
		super(props);

		this.state = {
		}
	}

	componentDidMount() {
		this.init();
	}
	componentDidUpdate( prevProps, prevState, snapshot ) 
	{ 
		super.componentDidUpdate( prevProps, prevState, snapshot ); 

		if ( prevProps.color != this.props.color )
		{
			this.get3dImage();
		}
	}	


	render() {
		if(!Detector.webgl){
			return(
				<div>WebGL not available</div>
			)
		}
		else{
			return (
				<div className="moc-viewer__stage-container moc-viewer__stage-container--part" onContextMenu={(e) => {e.preventDefault()}}>
					<div id="container" className="moc-viewer__stage moc-viewer__stage--part"/>
				</div>
			)
		}
	}

	init() {
		builder = new BRIGL.Builder("/3D/parts/",{ajaxMethod:"jquery"});	
		this.get3dImage();
	}

	get3dImage() {
		document.getElementById("container").innerHTML = "";
		let ldrawNo = `${this.props.id}.dat`;
		let color;
		if (this.props.color == 0) {
			color = 16;
		}
		else {
			color = this.props.color;
		}
		builder.loadModelByName(ldrawNo, {startColor:color, drawLines:true}, function(threejsMesh)
		{
			renderer = new BRIGL.BriglContainer(document.getElementById("container"), threejsMesh);
			renderer.render();
			
		}, () => this.loadingError());
	}

	loadingError() {
		this.triggerAlert("Sorry, We can  not display data of this brick");
		this.props.onError();
		builder = null;
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}
}